import { Heading } from "@chakra-ui/react";
import React from "react";

export default function MyMainHeading({ children }) {
  return <Heading>{children}</Heading>;
}
